import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { decryptAndValidate } from '@piqet-angular/data';
import {
  CustomModalService,
  LICENSE_LEVEL_LABEL,
  ManageUserService,
  noTextValue,
  superAdminRoleStr,
  UPDATE_USER,
  UpdatedByEnum,
} from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { MyOrganizationService } from 'libs/data/src/lib/services/my-organization/my-organization.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { AdminOrganizatioDataGridService } from 'libs/features/src/lib/layout/administrator/user-managment/admin-organization/admin-organization-data-grid.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription } from 'rxjs';
import { SignupSourceType, SignupSourceTypeArray } from 'libs/shared/src/lib/constants';

@Component({
  selector: 'piqet-angular-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
})
export class UserDetailsComponent implements OnChanges, OnDestroy {
  isChecked: any;
  organizationId: any;
  checkLicenseUpdateById = UpdatedByEnum.SuperAdmin;
  @Input() data: any = [];
  @Input() teamsData: any = [];
  @Input() isTeamsData: any;
  @Input() isNewsDetail: any;
  @Input() newsDetails: any;
  @Input() isShowEditButton: boolean = true;
  @Input() userInfoFromOrgMemberShip: boolean = false;
  selectedStatus: any;
  selectedLicense: any;
  licenseUpdatedBy!: number | null;
  private currentLicenseValue: any;
  statusComment: string = '';
  @Input() adminOrganizationData: any;
  @Input() isAdminOrganizationDetail: any;
  statusList: any;
  licenseLevelList: any;
  administratorService = inject(AdministratorService);
  modal = inject(CustomModalService);
  activeRoute = inject(ActivatedRoute);
  adminOrganizatioDataGridService = inject(AdminOrganizatioDataGridService);
  sharedService = inject(SharedService);
  _manageUserService = inject(ManageUserService);
  adminOrganizationCurrentValue: any;
  userRole: any;
  isRoleSuperAdmin: boolean = false;
  noValueText: string = noTextValue;
  isShowUpload = false;
  isShowCommentBox = false;
  commentText = '';
  sourceType: string = '';
  // pdf file
  fileFormateErrorMessage = '';
  selectedFilesTC: any;
  extFileTC = false;
  isShowChangeTC = false;
  formDataPayload: any;
  statusName = 'pending';
  activeRoutePath: any;
  @Output() organizationMembershipUser: EventEmitter<any> = new EventEmitter();
  @ViewChild('myFileInput', { static: false }) myFileInput!: ElementRef<HTMLInputElement>;
  licenseControl = new FormControl();
  private licenseSubscription!: Subscription;
  private isInitializing = true;

  constructor(
    private myOrganizationService: MyOrganizationService,
    private toaster: ToastrService,
    private cookieService: CookieService,
    private swalService: SwalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.activeRoute.paramMap.subscribe(params => {
      const encryptedOrgId = params.get('id');
      this.organizationId = decryptAndValidate(encryptedOrgId, 'OrganizationId', this.router) || 0;
      if (!this.organizationId) {
        return;
      }
    });
    this.licenseSubscription = this.licenseControl.valueChanges.subscribe(value => {
      // Don't trigger change during initialization
      if (!this.isInitializing && value !== this.currentLicenseValue) {
        this.changeLicenseLevel(value);
      }
    });
    this.activeRoutePath = this.activeRoute.snapshot.routeConfig?.path;
    const userRole = this.cookieService.get('u_type');
    this.userRole = this.sharedService.decodeURIComponentParam(userRole)?.toLowerCase();
    if (this.userRole == superAdminRoleStr) {
      this.isRoleSuperAdmin = true;
    }
  }

  fileChangeEvent(event: any) {
    const file: File = event.target.files[0];
    if (!file) {
      return;
    }
    const dotIndex = event.target.files[0].name.lastIndexOf('.');
    const fileFormat = event.target.files[0].name.slice(dotIndex);
    this.fileFormateErrorMessage = '';
    this.extFileTC = fileFormat.includes('.pdf') ? false : true;
    if (!this.extFileTC) {
      this.selectedFilesTC = event.target.files[0].name;
      this.isShowChangeTC = this.selectedFilesTC ? true : false;
      const formData: FormData = new FormData();
      formData.append('OrganizationId', this.organizationId);
      formData.append('ExcelFile', file);
      this.formDataPayload = formData;
      this.myOrganizationService
        .updateUploadTermsAndConditionsFile(this.formDataPayload)
        .pipe(
          catchError((error: any) =>
            of(this.toaster.error('An error occurred. Please try again later.'))
          )
        )
        .subscribe((res: any) => {
          if (!res.messageType) {
            this.adminOrganizationData = res.data;
            this.selectedStatus = this.adminOrganizationCurrentValue?.statusList.find(
              (status: any) => status.name === this.adminOrganizationData?.docStatus
            );
            this.isShowUpload =
              this.adminOrganizationData?.docStatus.toLowerCase() == this.statusName ? true : false;
            this.toaster.success(res.message);
          }
        });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isChecked = changes?.['data']?.currentValue?.isFlag;
    this.adminOrganizationCurrentValue = changes?.['adminOrganizationData']?.currentValue;
    this.isShowUpload =
      this.adminOrganizationCurrentValue?.docStatus.toLowerCase() == this.statusName ? true : false;
    const statusList = this.adminOrganizationCurrentValue?.statusList.filter(
      (x: any) => x.name != this.statusName
    );
    this.statusList = statusList;
    this.licenseLevelList = this.adminOrganizationCurrentValue?.licenseLevelList;
    this.statusComment = this.adminOrganizationCurrentValue?.docVerificationComment;
    this.selectedStatus = this.adminOrganizationCurrentValue?.statusList.find(
      (status: any) => status.name === this.adminOrganizationCurrentValue?.docStatus
    );
    this.selectedLicense =
      this.licenseLevelList && this.licenseLevelList.find((x: any) => x.selected);
    this.licenseUpdatedBy = this.adminOrganizationCurrentValue?.licenseUpdatedBy;
    this.licenseControl.setValue(this.selectedLicense, { emitEvent: false });
    this.currentLicenseValue = this.selectedLicense;
    this.isInitializing = false;
    this.sourceType =
      SignupSourceTypeArray.find(
        (source: any) => source.id === this.adminOrganizationCurrentValue?.signupSource
      )?.name ?? '';
    this.isShowCommentBox =
      this.adminOrganizationCurrentValue?.signupSource &&
      (this.adminOrganizationCurrentValue?.signupSource == SignupSourceType.Other ||
        this.adminOrganizationCurrentValue?.signupSource == SignupSourceType.ConferenceTradeEvent);
    this.commentText = this.adminOrganizationCurrentValue?.signupSourceComment ?? this.noValueText;
  }

  changePassword(event: any) {
    this.isChecked = event.target.checked;
    this.myOrganizationService
      .changePasswordOnNextLogin(this.data.userId, event.target.checked)
      .subscribe();
  }

  async editOrg() {
    const responseForAdd = await this.administratorService.GetAdminOrganizatioModalDataAsync(
      this.organizationId
    );
    this.sharedService.openEditOrgModal(responseForAdd?.data, 'Review organization detail', true);
  }

  async editUser(): Promise<void> {
    this._manageUserService.editUser(
      this.organizationId,
      UPDATE_USER,
      this.activeRoutePath,
      this.data?.organizationId,
      true
    );
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onChangeStatus(eve: any) {
    this.selectedStatus = eve;
    if (eve.id) {
      this.statusApiCall();
    }
  }

  statusApiCall() {
    const payload = {
      docStatus: this.selectedStatus.id,
      id: this.adminOrganizationData.organizationTermId,
      comment: this.statusComment ?? '',
    };
    this.sharedService.changeVerificationStatusDetail(payload).subscribe(async (res: any) => {
      if (!res.messageType) {
        const response = await this.myOrganizationService.getAdminOrganizationDetailsList(
          this.organizationId
        );
        this.adminOrganizationData = response.data;
        this.selectedStatus = this.adminOrganizationCurrentValue?.statusList.find(
          (status: any) => status.name === this.adminOrganizationData?.docStatus
        );
        this.isShowUpload =
          this.adminOrganizationData?.docStatus.toLowerCase() == this.statusName ? true : false;
        this.toaster.success(res.message);
        this.selectedFilesTC = null;
        this.isShowChangeTC = false;
      } else {
        this.toaster.error(res.message);
      }
    });
  }

  onBlurComment() {
    this.statusApiCall();
  }

  async addUser(myOrganizationManageUserId: any, actionLable: any) {
    const res = await this.myOrganizationService.getManageUserDataForAdd(
      myOrganizationManageUserId
    );
    this.modal.invoke('newMyOrganizationManageUser', {
      initialState: {
        newMyOrganizationManageUserData: res.data,
        label: actionLable,
        isOrgDetail: true,
        organizationId: this.organizationId,
      },
      class: 'modal-xl',
    });
    this.modal.ref?.content.saveManageUserEvent.subscribe((saveManageUserEvent: any) => {
      this.saveUser(saveManageUserEvent.payload);
    });
  }

  saveUser(userPayload: any) {
    this.myOrganizationService
      .addManageUser(userPayload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.modal.close();
          this.organizationMembershipUser.emit();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  changeLicenseLevel(value: any) {
    if (value?.id) {
      this.swalService.confirm('License level', LICENSE_LEVEL_LABEL).then(confirmed => {
        if (confirmed) {
          this.myOrganizationService
            .updateOrganizationLicenseLevel(this.organizationId, value.id)
            .subscribe(
              (res: any) => {
                if (res.messageType) {
                  this.toaster.error(res.message);
                  this.licenseControl.setValue(this.currentLicenseValue, { emitEvent: false });
                } else {
                  this.toaster.success(res.message);
                  this.currentLicenseValue = value;
                  this.selectedLicense = value;
                  this.licenseUpdatedBy = res.data;
                }
              },
              error => {
                this.toaster.error('Failed to update license level');
                this.licenseControl.setValue(this.currentLicenseValue, { emitEvent: false });
              }
            );
        } else {
          this.licenseControl.setValue(this.currentLicenseValue, { emitEvent: false });
        }
      });
    }
  }

  resetLicenseLevel() {
    this.myOrganizationService.resetOrganizationLicenseLevel(this.organizationId).subscribe(
      (res: any) => {
        if (res.messageType) {
          this.toaster.error(res.message);
        } else {
          this.toaster.success(res.message);
          this.selectedLicense =
            this.licenseLevelList &&
            this.licenseLevelList.find((x: any) => x.id == res.data.levelId);
          this.checkLicenseUpdateById = res.data.updatedBy;
          this.licenseControl.setValue(this.selectedLicense, { emitEvent: false });
        }
      },
      error => {
        this.toaster.error('Failed to reset license level');
      }
    );
  }

  ngOnDestroy() {
    // Don't forget to unsubscribe to prevent memory leaks
    if (this.licenseSubscription) {
      this.licenseSubscription.unsubscribe();
    }
  }
}
